import React from "react";

export interface OptionData {
  id: number;
  title: string;
  value: string | number | boolean;
  description?: string;
}
interface OptionSelectType {
  index?: number;
  title: string;
  subTitle?: string;
  options: OptionData[];
  onSelect: (value: number | string | boolean) => void;
  value: string | number | boolean;
  error?: string;
  noErrorMessage?: string;
  disabled?: boolean;
}
function OptionSelect({ index, title, subTitle, options, onSelect, value, error, noErrorMessage, disabled = false }: OptionSelectType) {
  const renderDescriptionOld = (description: string) => {
    return description.split(/(\*.*?\*)/g).map((part, index) => {
      if (part.startsWith("*") && part.endsWith("*")) {
        return (
          <span key={index} className="font-bold">
            {part.slice(1, -1)}
          </span>
        );
      }
      return part;
    });
  };

  const renderDescription = (description: string) => {
    return description.split(/(\*.*?\*|\[.*?\]\(.*?\))/g).map((part, index) => {
      if (part.startsWith("*") && part.endsWith("*")) {
        // Bold Text
        return (
          <span key={index} className="font-bold">
            {part.slice(1, -1)}
          </span>
        );
      } else if (part.startsWith("[") && part.includes("](") && part.endsWith(")")) {
        // Link
        const text = part.slice(1, part.indexOf("]("));
        const url = part.slice(part.indexOf("](") + 2, -1);
        return (
          <a key={index} href={url} target="_blank" rel="noopener noreferrer" className="font-semibold text-black underline">
            {text}
          </a>
        );
      } else {
        // Normal Text
        return <span key={index}>{part}</span>;
      }
    });
  };

  const getIconImage = (isEnabled: Boolean, selected: boolean) => {
    if (selected) {
      if (isEnabled) {
        return "/svg/checkmark.svg";
      } else {
        return "/icons/checkeditem.png";
      }
    } else {
      if (isEnabled) {
        return "/svg/circle.svg";
      } else {
        return "/icons/CheckInactive.png";
      }
    }
  };
  return (
    <div className="flex flex-col w-full">
      <div className="flex flex-col mb-[15px]">
        <div className="flex items-center">
          {index && <span className="content_count">{index}</span>}
          <span className="content_title">{title}</span>
        </div>
        {subTitle && <label className="notes-class-content !mb-[0px]">{renderDescription(subTitle)}</label>}
      </div>
      <div className="px-[1px] flex flex-col w-full">
        <ul className="flex flex-col gap-[15px]">
          {options.map(item => (
            //{items.map((item, index) => (
            <li
              onClick={() => {
                !disabled && onSelect(item.value);
              }}
              key={item.id}
              className="flex flex-col gap-[10px] bg-white "
              tabIndex={0}
              //   className="outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:rounded-md"
            >
              <div className="flex">
                <img
                  src={value === item.value ? getIconImage(!disabled, true) : getIconImage(!disabled, false)}
                  alt={item.title}
                  className="object-cover w-5 h-5"
                />
                <div className="flex-1 ml-[15px]">
                  <div className="content-subtitle-text">{item.title}</div>
                  {item.description && <div className="notes-class-light mb-[15px]">{renderDescription(item.description)}</div>}
                </div>
              </div>
              <div className=" bg-skseparatorgray w-full rounded-full h-[2px]" />
            </li>
          ))}
        </ul>
      </div>
      {error && <span className="block mb-2 text-sm text-red-600 dark:text-red-500">{error}</span>}
      {!error && noErrorMessage && <span className="block mb-2 text-sm text-gray-400 dark:text-gray-600">${noErrorMessage}</span>}
    </div>
  );
}

export default OptionSelect;
